import React from 'react';
import styled from 'styled-components';
import { OptionButton as FuseOptionButton } from '@tvg/fuse-design';
import { GetImageUrl } from 'utilities/media/media-util';
import { SiteName } from 'types/Site';

type Props = {
  name: string;
  id: string;
  label: string;
  swatchColour?: string;
  swatchImage?: string;
  checked: boolean;
  disabled: boolean;
  handleOnClick: (e: MouseEvent) => void;
  site: SiteName;
};

const StyledDiv = styled.div`
  label {
    border-color: var(--color-global-grey700);
    text-transform: capitalize;
    height: 4.8rem;

    &:hover {
      border-color: var(--color-global-black);
      color: var(--color-global-black);
      box-shadow: 0px 2px 8px 0px #00000033;
    }
  }

  span {
    overflow-wrap: anywhere;
  }

  .fuse-swatch {
    flex-basis: 2rem;
  }

  input:disabled + label .fuse-swatch {
    opacity: 0.4;
  }

  input:disabled + label {
    font-weight: var(--color-font-paragraph) !important;
    border-width: 1px !important;
    &:hover {
      box-shadow: none;
    }
  }

  input:checked + label {
    color: var(--color-global-black);
    font-weight: var(--font-weight-heading);
    border-width: 2px;
    box-shadow: none;
  }

  input:not(:disabled) + label:active {
    background: transparent !important;
    color: var(--color-global-black) !important;
    font-weight: var(--font-weight-heading);
    border-width: 2px;
  }

  input:focus-visible + label {
    box-shadow: 0px 2px 8px 0px #00000033;
    border-color: var(--color-global-black);
    color: var(--color-global-black);
  }
`;

function OptionButton(props: Props) {
  const { name, id, label, swatchColour, swatchImage, checked, disabled, handleOnClick, site } = props;

  const buildImageSwatchURL = (swatchImageValue?: string) => {
    let swatchImageURL = null;

    if (swatchImageValue) {
      swatchImageURL = GetImageUrl({ identifier: swatchImageValue, template: '$19x19_standard', format: 'jpg', site });
    }

    return swatchImageURL;
  };

  return (
    <StyledDiv>
      <FuseOptionButton
        type="checkbox"
        key={id}
        id={id}
        name={id}
        data-testid={`option-selector-button-${id.toLowerCase()}`}
        label={name === 'colour' ? label.toLowerCase() : label}
        swatchImage={buildImageSwatchURL(swatchImage)}
        swatchColour={swatchColour}
        checked={checked}
        disabled={disabled}
        onClick={handleOnClick}
      />
    </StyledDiv>
  );
}

export default OptionButton;
